import { ActionWithPayload } from "@obg/ngrx-utils";
import { updateState } from "@obg/ngx.global";

import { LOGIN_LIMIT_ACTION_TYPE, LOGIN_LIMIT_PROGRESS_ACTION_TYPE } from "./login-limit.action";
import { LoginLimit, LoginLimitProgressState, LoginLimitState, LoginLimitStatus } from "./login-limit.model";

const INITIAL_STATE: LoginLimitState = {};
const INITIAL_PROGRESS_STATE: LoginLimitProgressState = {
	currentProgress: undefined,
};

export function loginLimitReducer(state = INITIAL_STATE, action: ActionWithPayload): LoginLimitState {
	switch (action.type) {
		case LOGIN_LIMIT_ACTION_TYPE.getSuccess: {
			const limits: LoginLimit[] = action.payload.limits;

			if (limits.length) {
				const activeLoginLimit = limits.find((limit) => limit.status === LoginLimitStatus.Active);
				const queuedLoginLimit = limits.find((limit) => limit.status === LoginLimitStatus.Queued);

				const hasAnyLimit = activeLoginLimit !== undefined || queuedLoginLimit !== undefined;

				return updateState(state, {
					...{ isLimitsHistoryEmpty: false },
					...(hasAnyLimit ? { activeLoginLimit } : {}),
					...(hasAnyLimit ? { queuedLoginLimit } : {}),
				});
			}

			return updateState(state, { isLimitsHistoryEmpty: true });
		}
		case LOGIN_LIMIT_ACTION_TYPE.reset:
			return INITIAL_STATE;
		default:
			return state;
	}
}

export function loginLimitProgressReducer(
	state = INITIAL_PROGRESS_STATE,
	action: ActionWithPayload
): LoginLimitProgressState {
	switch (action.type) {
		case LOGIN_LIMIT_PROGRESS_ACTION_TYPE.getSuccess: {
			return updateState(state, {
				currentProgress: action.payload,
			});
		}
		case LOGIN_LIMIT_ACTION_TYPE.reset: {
			return INITIAL_PROGRESS_STATE;
		}
		default:
			return state;
	}
}
